module.exports = __webpack_public_path__ + "static/media/menu-categorias.f451250d.jpg";